"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BB8SystemType;

(function (BB8SystemType) {
  BB8SystemType["OpsPortal"] = "ops-portal";
  BB8SystemType["Billing"] = "billing";
})(BB8SystemType = exports.BB8SystemType || (exports.BB8SystemType = {}));

exports.default = BB8SystemType;